export default "__VITE_ASSET__DP6lkLwu__"